import React from "react";
import MonthCalendar from "./MonthCalendar";
import PlannerLegend from "./PlannerLegend";

export default function PlannerMonthView({
  currentMonth,
  data,
  isTeamView,
  isAdmin,
  onDayDoubleClick,
  onRefresh,
}) {
  const months = [currentMonth];

  return (
    <div className="month-view">
      <div className="month-view-grid">
        {months.map((m) => (
          <MonthCalendar
            key={`${m.year}-${m.month}`}
            year={m.year}
            month={m.month}
            data={data}
            isTeamView={isTeamView}
            isAdmin={isAdmin}
            onDayDoubleClick={onDayDoubleClick}
            onRefresh={onRefresh}
          />
        ))}
      </div>
      <PlannerLegend />
    </div>
  );
}
